import React from 'react';
import { Tag, TagProps } from '@rahtab/ui';

const LoadTag: React.VFC<LoadTagProps> = ({ status, statusCode }) => {
  const states: States = {
    '1': {
      backgroundColor: 'default',
      color: 'primary',
    },
    '2': {
      backgroundColor: 'primary',
      color: 'white',
    },
    '3': {
      backgroundColor: 'secondary',
      color: 'white',
    },
    '4': {
      backgroundColor: 'green',
      color: 'white',
    },
    '5': {
      backgroundColor: 'default',
      color: 'disabled',
    },
    controlled: {
      backgroundColor: 'white',
      color: 'primary',
    },
  };

  return (
    <Tag
      variant={statusCode === 'controlled' ? 'outlined' : 'contained'}
      backgroundColor={states[statusCode]?.backgroundColor}
      color={states[statusCode].color}
      text={status}
    />
  );
};
export default LoadTag;

interface LoadTagProps {
  status: string;
  statusCode: string;
}
interface States {
  [k: string]: { backgroundColor: TagProps['backgroundColor']; color: TagProps['color'] };
}
